<h2>{{title}}</h2>

<mat-radio-group aria-label="Select an option" [color]="color" [(ngModel)]="sexTraineeSelected">
  <mat-radio-button [checked]="sexTraineeSelected === s.sexKey" [value]="s.sexKey" *ngFor="let s of sexList">{{s.name}}
  </mat-radio-button>
</mat-radio-group>

<form *ngIf="traineeForm" [formGroup]="traineeForm" (ngSubmit)="onSubmit()">


  <div class="group_input">
    <mat-form-field appearance="outline">
      <mat-label>Nom</mat-label>
      <input matInput type="text" formControlName="lastname">
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Prénom</mat-label>
      <input matInput type="text" formControlName="firstname">
    </mat-form-field>
  </div>

  <div class="group_input">
    <mat-form-field appearance="outline" class="date">
      <mat-label>Date anniversaire</mat-label>
      <input matInput id="birthDate" (change)="test($event)" [matDatepicker]="birthDate" [max]="today"
        formControlName="birthDate" appInputDate (focus)="birthDate.open()">
      <mat-datepicker-toggle matSuffix [for]="birthDate"></mat-datepicker-toggle>
      <mat-datepicker #birthDate></mat-datepicker>
    </mat-form-field>

    <mat-list formArrayName="emergencyPhoneNumber" class="emergencyPhoneNumberList">
      <mat-list-item class="numberListItem"
        *ngFor="let control of getArray('emergencyPhoneNumber').controls; index as i" [formGroupName]="i">
        <div matLine>
          <mat-form-field appearance="outline">
            <mat-label>N° de téléphone</mat-label>
            <input matInput type="tel" placeholder="en cas d'urgence" [formControl]="control">
          </mat-form-field>
        </div>
        <button *ngIf="i !== 0" type="button" matTooltip="Retirer le téléphone" mat-icon-button color="primary"
          (click)="removeEmergencyPhoneNumber(i)">
          <fa-icon [icon]="getFaIcon('faTrashAlt')" appChangeColorTheme attribute="color"></fa-icon>
        </button>
      </mat-list-item>


      <mat-list-item *ngIf="getArray('emergencyPhoneNumber').controls.length < 8">
        <button type="button" mat-icon-button color="primary" matTooltip="Ajouter un téléphone"
          (click)="addEmergencyPhoneNumber()">
          <fa-icon [icon]="getFaIcon('faPlus')" appChangeColorTheme attribute="color"></fa-icon>
        </button>
      </mat-list-item>
    </mat-list>
  </div>


  <div>
    <mat-form-field appearance="outline">
      <mat-label>Ville</mat-label>
      <input matInput type="text" ngx-google-places-autocomplete (onAddressChange)="getAddressPracticePlace($event)"
        formControlName="city">
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Code postal</mat-label>
      <input matInput type="text" formControlName="postalCode" appNumbersOnly>
    </mat-form-field>

  </div>

  <div *ngIf="!isLoadingLicences">
    <h4>Licence(s)</h4>

    <mat-list formArrayName="licenceValues">
      <mat-list-item *ngFor="let control of getArray('licenceValues').controls; index as i" [formGroupName]="i">
        <div matLine class="oneLicence">
          <app-autocomplete class="licence-field" [control]="control.get('licence')" [list]="filteredLicences"
            label="Type de licence*"
            [hasTooltip]="control?.value?.licence?.description ? control.value.licence.description : false"
            [tooltipText]="control?.value?.licence?.description ? control?.value?.licence?.description : null">
          </app-autocomplete>

          <div class="valueAndRemove">
            <mat-form-field appearance="outline" class="value-field">
              <mat-label>Numéro de licence</mat-label>
              <input matInput type="text" formControlName="value">
            </mat-form-field>

            <button type="button" matTooltip="Retirer la licence" mat-icon-button color="primary"
              (click)="onRemoveLicence(i)" *ngIf="!data?.trainee?.licences || !data?.trainee?.licences[i]">
              <fa-icon [icon]="getFaIcon('faTrashAlt')" appChangeColorTheme attribute="color"></fa-icon>
            </button>
          </div>

          <p class="important" *ngIf="!control.get('licence').value || !control.get('value').value">Un emplacement de
            licence doit avoir un type de licence et un numéro de licence.</p>

        </div>


      </mat-list-item>


      <mat-list-item>
        <button type="button" mat-icon-button color="primary" matTooltip="Ajouter un numéro de licence"
          (click)="onAddLicence()">
          <fa-icon [icon]="getFaIcon('faPlus')" appChangeColorTheme attribute="color"></fa-icon>
          Renseigner son numéro de licence
        </button>
      </mat-list-item>
    </mat-list>
  </div>

  <mat-spinner *ngIf="isLoadingLicences" [diameter]="50"></mat-spinner>

  <div class="title_parameter" *ngIf="data?.trainee?.parameters?.length > 0">
    <h4>Paramètres*</h4>
    <p class="important">Les paramètres suivants sont requis afin que votre stagiaire soit en ordre.</p>
  </div>

  <div formArrayName="parameterValues" class="form_content" *ngIf="data?.trainee?.parameters?.length > 0">
    <ng-container *ngIf="getArray('parameterValues').controls.length">
      <div class="parameter_offer" *ngFor="let item of inputsParamOffer; let i = index;">
        <div [formGroup]="item.input" [ngSwitch]="item.type" class="form_content_inputs">

          <mat-checkbox [color]="color" formControlName="isDefault" (change)="changeIsDefault(i, $event)"
            matTooltip="Souhaitez-vous mettre cette valeur par défaut pour ce paramètre ?">En valeur par
            défaut</mat-checkbox>

          <ng-container *ngIf="i === 2">
            <mat-form-field appearance="outline" class="item_parameter" *ngSwitchCase="'texte'">
              <mat-label>{{item?.label}}</mat-label>
              <input matInput type="text" formControlName="selectedValue"
                (input)="setValueInput(i, $event, item.parameterKey)">
            </mat-form-field>
          </ng-container>

          <ng-container *ngIf="i !== 2">
            <mat-form-field appearance="outline" class="item_parameter" *ngSwitchCase="'texte'">
              <mat-label>{{item?.label}}</mat-label>
              <input matInput type="text" pattern="[^;#]+" formControlName="selectedValue"
                (input)="setValueInput(i, $event, item.parameterKey)">
            </mat-form-field>
          </ng-container>

          <ng-container *ngIf="i === 0">
            <mat-form-field appearance='outline' *ngSwitchCase="'date'">
              <mat-label>{{item?.label}}</mat-label>
              <input matInput [max]="today" formControlName="selectedValue" [matDatepicker]="picker"
                (focus)="picker.open()" (dateChange)="setValueInput(i, $event, item.parameterKey)">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </ng-container>

          <ng-container *ngIf="i !== 0">
            <mat-form-field appearance='outline' *ngSwitchCase="'date'">
              <mat-label>{{item?.label}}</mat-label>
              <input matInput [min]="today" formControlName="selectedValue" [matDatepicker]="picker"
                (focus)="picker.open()" (dateChange)="setValueInput(i, $event, item.parameterKey)">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </ng-container>

          <mat-form-field appearance="outline" class="item_parameter" *ngSwitchCase="'heure'">
            <mat-label>{{item?.label}}</mat-label>
            <input matInput type="time" formControlName="selectedValue"
              (input)="setValueInput(i, $event, item.parameterKey)">
          </mat-form-field>

          <mat-form-field appearance="outline" class="item_parameter" *ngSwitchCase="'valeur min/max'">
            <mat-label>{{item?.label}}</mat-label>
            <input matInput type="number" [min]="item.values[0]" [max]="item.values[1]" formControlName="selectedValue"
              (input)="setValueInput(i, $event, item.parameterKey)">
          </mat-form-field>

          <mat-form-field appearance="outline" *ngSwitchCase="'liste'">
            <mat-label>{{item?.label}}</mat-label>
            <mat-select formControlName="selectedValue"
              (valueChange)="setValueInput(i, $event, item.parameterKey, true)">
              <mat-option *ngFor="let v of item.values" [value]="v">{{v}}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" *ngSwitchCase="'checkbox'">
            <mat-label>{{item?.label}}</mat-label>
            <mat-select multiple formControlName="selectedValue"
              (valueChange)="setValueInput(i, $event, item.parameterKey, true)">
              <mat-option *ngFor="let  v of item.values" [value]="v">{{v}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </ng-container>
  </div>

  <p *ngIf="isMobile && (traineeForm.invalid || !sexTraineeSelected)" class="important">Votre formulaire est invalide ou
    certains champs requis ne sont pas remplis.</p>

  <div class="btn_action">
    <button type="button" class="back" (click)="dialogRef.close()">Annuler</button>

    <div matTooltip="Votre formulaire est invalide ou certains champs requis ne sont pas remplis."
      [matTooltipDisabled]="traineeForm.valid && sexTraineeSelected">
      <button type="submit" class="confirm" mat-raised-button [disabled]="traineeForm.invalid || !sexTraineeSelected"
        [style.opacity]="traineeForm.invalid || !sexTraineeSelected ? .5: 1" appChangeColorTheme
        attribute="bgc">{{btnConfirm}}</button>
    </div>

  </div>

</form>